import { GET } from '../request'

export const getEventos = mes =>
  GET('/api/profes/interno/eventos-calendario/list', { mes })
